import { c as _c } from "react/compiler-runtime";
import { Hint } from '@systemeio/ui';
import OptinRules from 'modules/stores/store/content/optin/optin-rules';
import { StoreId } from 'modules/stores/types/stores-interface';
import React from 'react';
import { DisclosureBox } from 'shared/components/disclosure-box';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
interface OptinOptionsProps {
  optinId?: number;
  storeId: StoreId;
}
export default function OptinOptions(t0) {
  const $ = _c(21);
  const {
    optinId,
    storeId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const t1 = optinId ? "button" : "div";
  const t2 = !optinId && "cursor-not-allowed";
  let t3;
  if ($[0] !== t2) {
    t3 = twMerge(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = !optinId;
  let t5;
  if ($[2] !== t) {
    t5 = t("dashboard.store.optin.rule.disabled");
    $[2] = t;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = !optinId;
  let t7;
  if ($[4] !== t) {
    t7 = t("dashboard.automation_rule.title_plural");
    $[4] = t;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t7) {
    t8 = <b className="text-text-primary text-start sm:text-base">{t7}</b>;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t5 || $[9] !== t6 || $[10] !== t8) {
    t9 = <Hint label={t5} showHint={t6}>{t8}</Hint>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== optinId || $[13] !== storeId) {
    t10 = optinId && <OptinRules optinId={optinId} storeId={storeId} />;
    $[12] = optinId;
    $[13] = storeId;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t1 || $[16] !== t10 || $[17] !== t3 || $[18] !== t4 || $[19] !== t9) {
    t11 = <DisclosureBox wrapperClassName="border border-text-secondary/30 rounded-lg" buttonAs={t1} buttonClassName={t3} disabled={t4} title={t9}>{t10}</DisclosureBox>;
    $[15] = t1;
    $[16] = t10;
    $[17] = t3;
    $[18] = t4;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}